import { render, staticRenderFns } from "./code-input.vue?vue&type=template&id=35e8a34b&scoped=true&"
import script from "./code-input.vue?vue&type=script&lang=js&"
export * from "./code-input.vue?vue&type=script&lang=js&"
import style0 from "./code-input.vue?vue&type=style&index=0&id=35e8a34b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8a34b",
  null
  
)

export default component.exports